/*
 * Builds a Rails params-compatible input field name
 *
 * @param fieldPrefix {string} Start of input field name; will not be wrapped in square brackets
 * @param path {Array<string | number>} Segments of the field name to be wrapped in square brackets
 * @returns {string} Rails params-compatible input field name
 *
 * @example
 *   getFieldName('some_field') // => 'some_field'
 *   getFieldName('some_model', 'nested_attributes', 'name') // => 'some_model[nested_attributes][name]'
 *   getFieldName('some_model', 'nested_attributes', 'names', '') // => 'some_model[nested_attributes][names][]'
 *
 */
export const getFieldName = (fieldPrefix: string, ...path: Array<string | number>) =>
  fieldPrefix + path.map((s) => `[${s}]`).join("")
